import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                                    <section>
                                        <div className="">
                                            <div className="ilead-rgt">
                                                <div className="innerpadding">
                                                    <div className="ilead-contentarea">
                                                        <div className="circle_title-first"><img
                                                            src={require('@images/greendot.jpg')}
                                                            alt=""/>Five key questioning areas</div>
                                                        <p>The following five questioning areas can be used to encourage
                                                            innovation and open-ended thinking.<a
                                                                className="superscripttext"
                                                                href="further_info.php?course=300"><sup>2</sup></a> Each
                                                            of these areas is discussed in more detail on the next page.
                                                        </p>
                                                        <div className="innovativeimg"><img
                                                            src={require('@images/nnovative_image1.jpg')}
                                                            alt=""/></div>
                                                        <div className="left-btn"><div
                                                             onClick={this.props.handleChangePage('Page2')}
                                                            className="button-next-previous-done thought">&lt;&lt; Previous </div></div>
                                                        <div className="right-btn"><div
                                                             onClick={this.props.handleChangePage('Page4')}
                                                            className="button-next-previous-done thought">Next &gt;&gt;</div></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}